<template>
  <div class="container">
    <zxEchart :title="canteen.canteen_name"
              :series="chartData"
              :date="dateTime | tsToDate"
              :acc_line="acc_line_set"
              class="chart-item"
              @barClick="barClick">
    </zxEchart>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {apiGetLabelTaskidByBar, apiQueryCanteenClassList} from '@/api';

import moment from 'moment';
import zxEchart from './zxEchart';

export default {
  name: "echartGetDish",
  components: {
    zxEchart
  },
  props: {
    item: {
      type: Object
    },
    acc_line: {
      type: String
    }
  },
  data() {
    return {
      dishClassList: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getModelList();
    });
  },
  methods: {
    ...mapMutations(["setSubTitle"]),
    async barClick (idx) {
      // console.log('assssssss');
      // console.log(id);
      const choose_class_id = this.chartData[idx].class_id;
      try {
        let {label_task_uuid_list} = await apiGetLabelTaskidByBar({
          canteen_id: this.canteen.canteen_id,
          day_ts: this.dateTime,
          class_id: choose_class_id
        });
        label_task_uuid_list = this.$_.uniq(label_task_uuid_list);
        if (label_task_uuid_list.length > 1) {
          this.$message.warning('多个批次包含此碗碟, 正在跳转到第一个碗碟');
          this.$router.push({
            name: 'taskHistoryRecheck',
            params: {
              checkMode: false,
              class_id: choose_class_id,
              taskInfo: {
                day_ts: this.dateTime,
                label_task_uuid: label_task_uuid_list,
                ...this.canteen
              }
            }
          });
        } else if (label_task_uuid_list.length === 1) {
          this.$message.warning('正在跳转');
          this.$router.push({
            name: 'taskHistoryRecheck',
            params: {
              checkMode: false,
              class_id: choose_class_id,
              taskInfo: {
                day_ts: this.dateTime,
                label_task_uuid: label_task_uuid_list,
                ...this.canteen
              }
            }
          });
        }
      } catch (e) {
      }
    },
    async getModelList() {
      try {
        const res = await apiQueryCanteenClassList({
          canteenId: this.canteen.canteen_id,
          apiKey: this.userinfo().api_key
        });
        this.dishClassList = res.dish_info_list;
      } catch (e) {
        console.log(e);
        this.$message.error(e.message);
      }
    },
    ...mapActions([])
  },
  filters: {
    tsToDate(ts) {
      console.log(ts);
      return moment(ts * 1000).format('YYYY-MM-DD');
    }
  },
  computed: {
    ...mapGetters(['userinfo']),
    acc_line_set () {
       return this.acc_line;
    },
    dateTime () {
      return this.item.day_ts;
    },
    dish_acc_info_list() {
      const dish_acc_info_list = this.$_.cloneDeep(this.item.dish_acc_info_list);
      if (this.$_.isEmpty(this.dishClassList)) {
        return [];
      } else {
        dish_acc_info_list.forEach(a => {
          const res = this.$_.find(this.dishClassList, (b) => b.class_id === a.class_id);
          if (res) {
            this.$set(a, 'dish_name', res.dish_name ? res.dish_name : res.dish_native_name ? res.dish_native_name
              : '无名称');
            this.$set(a, 'dish_image_url', res.dish_image_url);
          } else {
            this.$set(a, 'dish_name', '无名称');
            this.$set(a, 'dish_image_url', '');
          }
        });
        return dish_acc_info_list;
      }
    },
    canteen() {
      const { canteen_name, canteen_id } = this.item;
      return { canteen_name, canteen_id };
    },
    chartData() {
      return this.dish_acc_info_list;
    }
  },
  watch: {}
};
</script>
<style scoped lang="scss">
  .container {
    width: 100%;
    height: 100%;
  }
</style>
